import { createContainerStructure } from 'client/utils/createStructureUtils'
import { EntityWithChildIdsMigrationType } from 'common/types/entities/EntityInterface'
import { createAgreement } from 'src/shared/entities/agreement/create-agreement'
import { insertChild } from 'src/shared/entities/utils/generate-base-entity'

export const createAgreementFromLibrary = (
  container: EntityWithChildIdsMigrationType,
  locale: string,
  position = 0,
) => {
  const { structure, descendantEntity } = createContainerStructure(
    container,
    locale,
    position,
  )

  const agreementEntity = createAgreement(
    descendantEntity.id,
    descendantEntity.masterBlockId,
  )

  return {
    ...structure,
    [descendantEntity.id]: {
      ...descendantEntity,
      childIds: insertChild(
        descendantEntity.childIds,
        agreementEntity.id,
        position,
      ),
    },
    [agreementEntity.id]: agreementEntity,
  }
}
